import { Modal } from '@smartgift/frontend-toolkit';
import { useEffect, useMemo, useState } from 'react';

import { EDIT_RECIPIENT_STEP, REVIEW_AND_CONFIRM_STEP } from './constant';
import { EditModalContext } from './context';
import { EditRecipient } from './EditRecipient';
import { ReviewAndConfirm } from './ReviewAndConfirm';

function ContactsEditModal({
  isCCPayment,
  isModalOpen,
  isLiveFeature,
  onRequestClose,
  selectedContactIds,
  updateContacts,
  ...props
}) {
  const [step, setStep] = useState(EDIT_RECIPIENT_STEP);
  const [modalObject, setModalObject] = useState({});
  const [contextValue, setContextValue] = useState({});

  const contactRows = useMemo(
    () =>
      selectedContactIds?.reduce((result, contactId) => ({ ...result, [contactId]: true }), {}) ||
      {},
    [selectedContactIds]
  );

  const [selectedRows, onChangeSelectedRows] = useState({});

  useEffect(() => {
    onChangeSelectedRows(isLiveFeature ? {} : { ...contactRows });
  }, [isLiveFeature, contactRows]);

  const componentList = {
    [EDIT_RECIPIENT_STEP]: EditRecipient,
    [REVIEW_AND_CONFIRM_STEP]: ReviewAndConfirm
  };

  const Component = componentList[step];

  useEffect(() => {
    if (isModalOpen) {
      setStep(EDIT_RECIPIENT_STEP);
    }
  }, [isModalOpen]);

  return (
    <EditModalContext.Provider value={{ ...contextValue, isCCPayment, setContextValue }}>
      <Modal isOpen={isModalOpen} onRequestClose={onRequestClose} size="xl" {...modalObject}>
        <Component
          isCCPayment={isCCPayment}
          updateContacts={updateContacts}
          contactRows={contactRows}
          isModalOpen={isModalOpen}
          isLiveFeature={isLiveFeature}
          onRequestClose={onRequestClose}
          setStep={setStep}
          setModalObject={setModalObject}
          selectedRows={selectedRows}
          onChangeSelectedRows={onChangeSelectedRows}
          {...props}
        />
      </Modal>
    </EditModalContext.Provider>
  );
}

export { ContactsEditModal };
